export default __webpack_public_path__ + "static/media/openIMISFull.4fe6b120.png";